import Food from '@components/offer/models/Food';
import UIBaseModel from '@models/UIBaseModel';
import { ButtonBase } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';

interface FoodBaseButtonProps {
    food: UIBaseModel;
    onClick: (food: Food) => void;
    children: React.ReactNode;
}

const FoodBaseButton: React.FC<FoodBaseButtonProps> = observer(({ children, food, onClick }) => {
    return (
        <ButtonBase
            onClick={() => onClick(food as Food)}
            sx={(theme) => ({
                boxShadow: food.isSelected ? theme.shadows[7] : theme.shadows[9],
                width: "100%",
                backgroundColor: food.isSelected ? theme.palette.secondary.light : "inherit",
                // [theme.breakpoints.up("md")]: {
                //     width: "49%"
                // },
                "&:hover": {
                    boxShadow: theme.shadows[1],
                    "& #food-item-right-icon": {
                        right: -4
                    },
                },
            })}>
            {children}
        </ButtonBase>
    )
})

export default FoodBaseButton;